import { Fragment, useCallback, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { BsCheckLg } from "react-icons/bs";
import { HiChevronUpDown } from "react-icons/hi2";

// const dataArr = [
//   { id: 1, name: 'Wade Cooper' },
//   { id: 2, name: 'Arlene Mccoy' },
//   { id: 3, name: 'Devon Webb' },
//   { id: 4, name: 'Tom Cook' },
//   { id: 5, name: 'Tanya Fox' },
//   { id: 6, name: 'Hellen Schmidt' },
// ]

const INITIAL_VISIBLE = 50;  // items shown before typing
const MAX_RESULTS = 100;      // items shown after filtering

export default function SelectComponentWithSearch({
  title,
  selected,
  setSelected,
  placeholder,
  dataArr,
  required = false
}) {
  // const [selected, setSelected] = useState(people[0])
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [debounceTimer, setDebounceTimer] = useState(null);

  const handleQueryChange = useCallback((event) => {
    const value = event.target.value;
    setQuery(value);
    if (debounceTimer) clearTimeout(debounceTimer);
    const timer = setTimeout(() => {
      setDebouncedQuery(value);
    }, 200);
    setDebounceTimer(timer);
  }, [debounceTimer]);

  const filteredData =
    debouncedQuery === ""
      ? dataArr.slice(0, INITIAL_VISIBLE)
      : dataArr
          .filter((data) =>
            data.name
              .toLowerCase()
              .replace(/\s+/g, "")
              .includes(debouncedQuery.toLowerCase().replace(/\s+/g, ""))
          )
          .slice(0, MAX_RESULTS);

  // const [show, setShow] = useState(false);


  return (
    <div className="w-full">
      <Combobox value={selected} onChange={setSelected}>
        <Combobox.Label className="block text-sm font-medium leading-6 text-gray-900 mb-0">
          {title} {required && " * "}
        </Combobox.Label>
        <div className="relative">
          <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left focus:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
            <Combobox.Input
              className="focus:!border-blue-500 focus:shadow-md capitalize bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 transition-all"
              displayValue={(person) => person?.name ?? ""}
              // onClick={ (e) => setShow(!show)}
              placeholder={placeholder}
              onChange={handleQueryChange}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
              <HiChevronUpDown
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Combobox.Button>
          </div>
          <Transition
            // show={show}
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => { setQuery(""); setDebouncedQuery(""); }}
          >
            <Combobox.Options className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-2 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {filteredData.length === 0 && query !== "" ? (
                <div className="relative cursor-default select-none py-2.5 px-4 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                <>
                  {filteredData.map((each, idx) => (
                    <Combobox.Option
                      key={idx}
                      className={({ active }) =>
                        `relative cursor-default select-none py-2.5 pl-10 pr-4 ${
                          active ? "bg-teal-600 text-white" : "text-gray-900"
                        }`
                      }
                      value={each}
                    >
                      {({ selected, active }) => (
                        <>
                          <span
                            className={`block capitalize truncate ${
                              selected ? "font-medium" : "font-normal"
                            }`}
                          >
                            {each.name}
                          </span>
                          {selected ? (
                            <span
                              className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                                active ? "text-white" : "text-teal-600"
                              }`}
                            >
                              <BsCheckLg className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Combobox.Option>
                  ))}
                  {debouncedQuery === "" && dataArr.length > INITIAL_VISIBLE && (
                    <div className="relative cursor-default select-none py-2 px-4 text-xs text-gray-400 text-center border-t">
                      Showing {INITIAL_VISIBLE} of {dataArr.length} — type to search more
                    </div>
                  )}
                </>
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}
